import { useState } from "react";
import "swiper/css";
import { Swiper, SwiperSlide } from "swiper/react";
import Common_Btn from "../../../common/common-btn/Common_Btn";
import White_Btn from "../../../common/common-btn/white-btn/White_Btn";
import Form_Header from "../../../common/form-header/Form_Header";
import "./Create_Account_Step4.css";

const Create_Account_Step4 = ({ setStep }) => {
  const numbers = Array.from({ length: 500 }, (_, i) => i + 100);

  // ✅ Default height
  const defaultHeight = 200;
  const [height, setHeight] = useState(defaultHeight);

  return (
    <section className="step1_wrapper step3_wrapper step4_wrapper">
      <Form_Header step={4} totalSteps={6} />

      <div className="weight_selection_div">
        <h2 className="select_title">Select Your Height</h2>

        <div className="weight_wrapper height_wrapper">
          {/* Center Selected Height */}
          <h1 className="weight_value">
            {height} <span>cm</span>
          </h1>

          <div className="scale_container">
            <div className="center_line" />

            <Swiper
              slidesPerView={10}
              centeredSlides={true}
              spaceBetween={10}
              grabCursor={true}
              initialSlide={defaultHeight - 100}
              onSlideChange={(swiper) => {
                setHeight(numbers[swiper.activeIndex]);
              }}
              className="height_swiper"
            >
              {numbers.map((num) => (
                <SwiperSlide key={num}>
                  {({ isActive }) => (
                    <div className={`scale_item ${isActive ? "active" : ""}`}>
                      {num}
                    </div>
                  )}
                </SwiperSlide>
              ))}
            </Swiper>
          </div>
        </div>

        <div className="form_btn_holder">
          <White_Btn btnText="Back" onClick={() => setStep(3)} />
          <Common_Btn btnText="Next" onClick={() => setStep(5)} />
        </div>
      </div>
    </section>
  );
};

export default Create_Account_Step4;
